/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Input /* The above code is a comment in JavaScript. It is not doing anything in terms of
functionality, but it is used to provide information or explanations about the
code to other developers. */,
  Typography,
} from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const fieldsOption = [
  {
    value: "Nông nghiệp, lâm nghiệp, thủy sản",
    label: "Nông nghiệp, lâm nghiệp, thủy sản",
  },
  {
    value: "Công nghiệp, xây dựng",
    label: "Công nghiệp, xây dựng",
  },
  {
    value: "Thương mai, dịch vụ",
    label: "Thương mai, dịch vụ",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    fields: {
      type: "select",
      value: null,
      bg: false,
      option: fieldsOption,
    },
    totalStaff: {
      type: "input",
      value: 0,
      bg: false,
    },
    revenue: {
      type: "input",
      value: 0,
      bg: false,
    },
    capital: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];

export default function SubTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    // const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      fields: {
        type: "select",
        value: null,
        bg: false,
        option: fieldsOption,
      },
      totalStaff: {
        type: "input",
        value: null,
        bg: false,
      },
      revenue: {
        type: "input",
        value: null,
        bg: false,
      },
      capital: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Lĩnh vực hoạt động
              </Td>
              <Td colSpan={1} style={{ textAlign: "center" }}>
                Số lao động
              </Td>
              <Td colSpan={1} style={{ textAlign: "center" }}>
                Doanh thu (VNĐ)
              </Td>
              <Td colSpan={1} style={{ textAlign: "center" }}>
                Nguồn vốn (VNĐ)
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.fields.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.fields?.type !== "select" ? (
                      row.fields.value
                    ) : (
                      <SelectTable
                        name="fields"
                        id={row.id.value}
                        option={row.fields.option ? row.fields.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.totalStaff.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalStaff?.type !== "input" ? (
                      row.totalStaff.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="totalStaff"
                        value={row.totalStaff.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.capital.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.capital?.type !== "input" ? (
                      row.capital.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="capital"
                        value={row.capital.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
